import classNames from 'classnames';
import { ForwardedRef, HTMLAttributes, ReactNode } from 'react';

import styles from '../../styles/themes/uniprix.module.css';

interface UniprixProps extends HTMLAttributes<HTMLDivElement> {
    className?: string;
    children: ReactNode;
}

function UniprixTheme({
    children,
    className = null,
    ref: containerRef = null,
    ...props
}: UniprixProps & { ref?: ForwardedRef<HTMLDivElement> | null }) {
    return (
        <div className={classNames([className, styles.container])} ref={containerRef} {...props}>
            {children}
        </div>
    );
}

export default UniprixTheme;
